import { render, staticRenderFns } from "./MemoButton.vue?vue&type=template&id=454af127&scoped=true"
import script from "./MemoButton.vue?vue&type=script&lang=ts"
export * from "./MemoButton.vue?vue&type=script&lang=ts"
import style0 from "./MemoButton.vue?vue&type=style&index=0&id=454af127&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454af127",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/memo-button.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2FMemoButton.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports